module.exports = __webpack_public_path__ + "img/電気回路_4_5_3.f2b1312c.png";